<template>
  <div id="changePass">
  <div class="container" style="padding:100px 0px 30px 0px;">
        <div class="row justify-content-center align-items-center">
          <div class="card" style="padding: 20px">
            <article class="card-body">
              <h4 class="card-title text-center mb-4 mt-1">
                <img src="/img/logotipo-pubtec.png" height="70"/>
              </h4>
              <hr>
              <!--<p class="text-success text-center">Some message goes here</p>-->
              <form>
                <div class="form-group">
                  <label>Nova senha:</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input id="first_pass" class="form-control" type="password">
                  </div> <!-- input-group.// -->
                </div> <!-- form-group// -->
                <div class="form-group">
                  <label>Confirme a senha:</label>
                  <div class="input-group">
                    <div class="input-group-prepend">
                      <span class="input-group-text"> <i class="fa fa-lock"></i> </span>
                    </div>
                    <input class="form-control" v-model="pass" type="password">
                  </div> <!-- input-group.// -->
                </div> <!-- form-group// -->
                <div class="form-group">
                  <a @click="changePass()" class="btn btn-primary btn-block"> Alterar senha  </a>
                </div> <!-- form-group// -->
              </form>
            </article>
          </div> <!-- card.// -->
        </div>
      </div><!-- /container -->
  </div>
</template>

<script>
  import auth from '../api/auth'

  export default {
    name: "ChangePass",
    data () {
      return {
        hash: '',
        pass: ''
      }
    },
    methods: {
      changePass(){
        if(this.pass !== $('#first_pass').val() || this.pass === '') alert('As senhas precisam ser iguais')
        else {
          auth.confirmPassword({hash: this.hash, password: this.pass}).then((response) => {
            if(response.status === 200) {
              alert('Senha alterada com sucesso')
              this.$router.push({name: 'login'})
            }
        })
        }
      }
    },
    mounted(){
      this.hash = this.$route.params.hash
    }
  }
</script>

<style scoped>
  form{ min-width: 300px; }
</style>
